/**
 * @generated SignedSource<<669570516113064080a80e203300f536>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type removeApprover_softwareReleasesApprovers_jiraVersionApprover$data = {
  readonly __id: string;
  readonly id: string;
  readonly " $fragmentType": "removeApprover_softwareReleasesApprovers_jiraVersionApprover";
};
export type removeApprover_softwareReleasesApprovers_jiraVersionApprover$key = {
  readonly " $data"?: removeApprover_softwareReleasesApprovers_jiraVersionApprover$data;
  readonly " $fragmentSpreads": FragmentRefs<"removeApprover_softwareReleasesApprovers_jiraVersionApprover">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "removeApprover_softwareReleasesApprovers_jiraVersionApprover",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ClientExtension",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "__id"
        }
      ]
    }
  ],
  "type": "JiraVersionApprover"
};

(node as any).hash = "20e18f6c71fb765cb93bd4418c0f9640";

export default node;
